module.exports = __webpack_public_path__ + "static/media/back.b90cddf2.svg";